<div>
    <form action="https://{{hostedUrlNoHttp}}/payment/payment-completed" class="paymentWidgets" data-brands="VISA MASTER AMEX"> </form>
    <!-- <form action="https://localhost:4200/payment/initiate" class="paymentWidgets" data-brands="VISA MASTER AMEX">  </form>-->
</div>